import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DINNumberUpdateModalUI from './DINNumberUpdateModalUI'

class DINNumberUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      dinNumber: props.selectedUser && props.selectedUser.dinNumber ? props.selectedUser.dinNumber : '',
      dinNumberError: null,
    }
  }

  render() {
    return (
      <DINNumberUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        dinNumber={this.state.dinNumber}
        onDinNumberChange={(event) => { this.setState({ dinNumber: event.target.value }) }}
        dinNumberError={this.state.dinNumberError}
        setDinNumberError={(error) => { this.setState({ dinNumberError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedUser !== this.props.selectedUser) {
      this.setState({
        dinNumber: this.props.selectedUser && this.props.selectedUser.dinNumber ? this.props.selectedUser.dinNumber : ''
      });
    }
  }


  onSubmit = () => {
    if (this.state.submitted) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(
      this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/user/${this.props.selectedUserId}/dinNumber`,
      this.onSubmitCallback,
      {
        dinNumber: this.state.dinNumber
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList) {
      response.errorList.forEach(error => errorList.push(error.message))
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList })
  }
}

export default DINNumberUpdateModalSF